import Api from '@/services/Api'

export default {
  index (params) {
    return Api().post('careUser', params)
  },
  create (params) {
    return Api().post('careUserNew', params)
  },
  show (params) {
    return Api().post('careUserEdit', params)
  },
  update (params) {
    return Api().post('careUserUpdate', params)
  },
  state (params) {
    return Api().post('careUserState', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/CareUserService.js